<template>
  <div class="carInfoContent">
    <el-collapse v-model="activeNames">
      <el-collapse-item name="carInfo">
        <template #title>
          <span>
            <img src="../../assets/svg/carInfo.svg" alt="" />
            车辆信息
          </span>
        </template>
        <el-descriptions :column="3" border>
          <el-descriptions-item label="VIN">
            <span v-if="form.carType == 1">{{ form.vin }}</span>
            <span
              v-if="
                form.carType == 0 &&
                form.vinCheckRespList &&
                form.vinCheckRespList.length > 0
              "
              @click="handleLookAllVin"
              class="lineTheme"
              >查看</span
            >
          </el-descriptions-item>
          <el-descriptions-item label="车型">{{
            form.carModel
          }}</el-descriptions-item>
          <el-descriptions-item label="车辆属性">
            {{ form.carAttribute == 0 ? "燃油车" : "电动车" }}
          </el-descriptions-item>
          <el-descriptions-item label="销售日期" v-if="form.carType === 1">{{
            form.saleDate
          }}</el-descriptions-item>
          <el-descriptions-item label="生产日期" v-if="form.carType == 1">{{
            form.productionDate
          }}</el-descriptions-item>
          <el-descriptions-item label="行驶里程" v-if="form.carType === 1"
            >{{ form.drivingDistance }}km</el-descriptions-item
          >
        </el-descriptions>
      </el-collapse-item>
    </el-collapse>
    <vin-list-dialog ref="vinListDialog" />
  </div>
</template>
<script>
import VinListDialog from "@/views/feedbackNew/allCar/components/vinListDialog.vue";
export default {
  name: "carInfo",
  components: { VinListDialog },
  data() {
    return {
      activeNames: ["carInfo"], // 全部展开
      form: {},
    };
  },
  props: {
    carList: {
      type: [Array, Object],
      // default:() => []
    },
  },
  async created() {
    this.getCarInfo();
  },
  methods: {
    // 获取数据
    getCarInfo() {
      if (this.carList) {
        this.form = this.carList;
      }
    },
    // 查看全部vin码
    handleLookAllVin() {
      this.$refs.vinListDialog.init(
        "查看全部",
        this.form.carAttribute,
        this.form.faultType,
        this.form.vinCheckRespList
      );
    },
  },
};
</script>
